class ViewMapping {

	/**
	 * @param {Context} context
	 * @param {String} selector
	 * @param {View} ViewClass
	 * @param {ViewMediator} ViewMediatorClass
	 */
	constructor(context, selector, ViewClass, ViewMediatorClass) {

		// Make ES6 compatible
		if (typeof ViewClass == 'object' && ViewClass.default) {
			ViewClass = ViewClass.default;
		}

		if (typeof ViewMediatorClass == 'object' && ViewMediatorClass.default) {
			ViewMediatorClass = ViewMediatorClass.default;
		}

		// Store params
		this.context = context;
		this.selector = selector;
		this.ViewClass = ViewClass;
		this.ViewMediatorClass = ViewMediatorClass;

		// Init book keeping arrays
		this.mediators = [];
		this.views = [];
	}

	/**
	 * Run the mapping, creating the view if necessary
	 *
	 * @return {ViewMapping}
	 */
	build() {
		var elements = document.querySelectorAll(this.selector);
		if (!elements.length) {
			return this;
		}

		// Create the views
		for (let i = 0; i < elements.length; i++) {
			this._createView(elements[i]);
		}

		return this;
	}

	/**
	 * Destroy all views that may have been created by this mapping.
	 *
	 * @return {ViewMapping}
	 */
	destroy() {
		for (let i = 0; i < this.views.length; i++) {
			this._destroyView(this.views[i]);
		}

		this.views = [];

		return this;
	}

	/**
	 * @param {Node} el
	 * @private
	 */
	_createView(el) {
		if (typeof this.ViewClass === 'undefined') {
			console.log('Cannot create View for selector ' + this.selector);
		}

		// Create the view
		var view = new this.ViewClass({
			el: el,
			signals: this.context.signals
		});
		this.views.push(view);

		// Create the mediator if one is provided
		if (this.ViewMediatorClass) {
			var mediator = new this.ViewMediatorClass(view);
			mediator.register();

			this.mediators.push(mediator);
		}
	}

	/**
	 * @param view
	 * @private
	 */
	_destroyView(view) {

		// If it has a destroy method, call that
		if (view.destroy) {
			view.destroy();
			return;
		}

		// Otherwise, just remove it from the dom
		if (view.el.parentNode) {
			view.el.parentNode.removeChild(view.el);
		}
	}

	/**
	 * @returns {String}
	 */
	toString() {
		return '[object ViewMapping]';
	}
}

export default ViewMapping;


// WEBPACK FOOTER //
// ./js/Core/ViewMapping.js